import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "h-100 d-flex flex-column commerce" };
const _hoisted_2 = { class: "header-bar" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_banner_panel = _resolveComponent("g-banner-panel");
    const _component_g_ecommerce__message_bar = _resolveComponent("g-ecommerce__message-bar");
    const _component_g_sticky_bar = _resolveComponent("g-sticky-bar");
    const _component_g_ecommerce__top_bar = _resolveComponent("g-ecommerce__top-bar");
    const _component_g_ecommerce__nav_bar = _resolveComponent("g-ecommerce__nav-bar");
    const _component_g_ecommerce__nav_mobile = _resolveComponent("g-ecommerce__nav-mobile");
    const _component_g_ecommerce_footer = _resolveComponent("g-ecommerce-footer");
    const _component_g_toast_container = _resolveComponent("g-toast-container");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_g_banner_panel),
        _createVNode(_component_g_ecommerce__message_bar),
        _createVNode(_component_g_sticky_bar, { "bar-object": _ctx.getStickyMenu }, null, 8, ["bar-object"]),
        _createElementVNode("header", _hoisted_2, [
            _createVNode(_component_g_ecommerce__top_bar),
            _createVNode(_component_g_ecommerce__nav_bar),
            _createVNode(_component_g_ecommerce__nav_mobile)
        ]),
        _createElementVNode("div", _mergeProps({
            class: [_ctx.widthMode === 'full' ? 'container-fluid p-0' : 'container'],
            style: { "flex": "1 1 0", "order": "2" }
        }, _ctx.metaData?.layout_settings), [
            _renderSlot(_ctx.$slots, "default")
        ], 16),
        _createVNode(_component_g_ecommerce_footer),
        _createVNode(_component_g_toast_container)
    ]));
}
